/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface VisitorMapAndHours { 
    archived?: boolean;
    createdAt?: string;
    hoursHeader?: string;
    hoursNote?: string;
    id?: string;
    importObjectKey?: string;
    importSessionKey?: string;
    learnMoreButton?: string;
    locked?: boolean;
    phone?: string;
    published?: boolean;
    readOnly?: boolean;
    text?: string;
    toll?: string;
    updatedAt?: string;
    version?: number;
    weekdayHours?: string;
    weekdayHoursText?: string;
    weekendHours?: string;
    weekendHoursText?: string;
}
